import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broadcastings-broadcasting-new-schedule',
  templateUrl: './broadcastings-broadcasting-new-schedule.component.html',
  styleUrls: ['./broadcastings-broadcasting-new-schedule.component.scss']
})
export class BroadcastingsBroadcastingNewScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
